export class clsEstimateCond {
  segment: string;
  size: string;
  dweek: {
    date: (Date | null);
    mdate: (Date | null);
  }
  constructor(segment: string, size: string) {
    this.segment = segment;
    this.size = size;
    this.dweek = {
      date: null,
      mdate: null
    }
  }
}